import React from 'react'
import { Container } from 'reactstrap'
import {
  StyledContainer,
  StyledTitle,
  StyledInfo,
  StyledContentWrapper,
  StyledButton,
  StyledLink
} from './styles'

const preferencesLink = 'https://account.pga.org/job-preferences'

export default () => {
  return (
    <Container>
      <StyledContainer>
        <StyledContentWrapper>
          <StyledTitle>No recommended jobs at this time </StyledTitle>
          <StyledInfo>
            Jobs are updated frequently, please check back soon. You can also try modifying{' '}
            <StyledLink href={preferencesLink}>your job preferences</StyledLink> to widen your career interests.
          </StyledInfo>
        </StyledContentWrapper>
        <a href={preferencesLink}>
          <StyledButton outline>Job Preferences</StyledButton>
        </a>
      </StyledContainer>
    </Container>
  )
}
